var map = {
	"./10label.png": "cNb7",
	"./11label.png": "G/kR",
	"./1label.png": "mB5d",
	"./2label.png": "Mq+E",
	"./3label.png": "9zbK",
	"./4label.png": "OBId",
	"./5label.png": "v+DN",
	"./6label.png": "oDAy",
	"./7label.png": "k/JG",
	"./8label.png": "kc1k",
	"./9label.png": "ZygE"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "jg/0";